module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 169.5"><path class="st0" d="M2 1v137l198.1 29.5L398 138.7V1S1.6 1.4 2 1z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/result/btn-share-bg.svg
// module id = 452
// module chunks = 1